import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUser,
  faCalendarAlt,
  faClock,
  faQuestionCircle,
  faEye,
  faTrashAlt,
  faEdit,
  faEyeSlash,
  faCalendar,
  faChartBar,
  faBarChart
} from '@fortawesome/free-regular-svg-icons'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import {
  faLock,
  faBars,
  faUserCircle,
  faTimesCircle,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faPlayCircle,
  faSync,
  faCheckCircle,
  faAngleDoubleLeft,
  faCheck,
  faTimes,
  faExclamation,
  faCrosshairs,
  faPuzzlePiece,
  faPlus,
  faChartPie,
  faBookOpen,
  faUsers,
  faHourglassEnd,
  faFilePen,
  faFileCirclePlus,
  faBuildingColumns,
  faQrcode,
  faS,
  faB,
  faI,
  faT,
  faLaptopFile,
  faCodeBranch,
  faIdBadge,
  faUserPen,
  faBook,
  faLaptop,
  faArrowRightFromBracket
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUser,
  faLock,
  faBars,
  faUserCircle,
  faTimesCircle,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faYoutube,
  faCalendarAlt,
  faClock,
  faPlayCircle,
  faQuestionCircle,
  faSync,
  faCheckCircle,
  faAngleDoubleLeft,
  faCheck,
  faTimes,
  faExclamation,
  faCrosshairs,
  faPuzzlePiece,
  faEye,
  faTrashAlt,
  faEdit,
  faEyeSlash,
  faPlus,
  faCalendar,
  faChartPie,
  faUsers,
  faBookOpen,
  faHourglassEnd,
  faFilePen,
  faFileCirclePlus,
  faBuildingColumns,
  faQrcode,
  faS,
  faT,
  faB,
  faI,
  faLaptopFile,
  faCodeBranch,
  faIdBadge,
  faChartBar,
  faBarChart,
  faBook,
  faLaptop,
  faUserPen,
  faArrowRightFromBracket
)

const ASSET_PATH = 'https://static.upmyranks.com/'

export const ICONS = {
  CHEMISTRY: `${ASSET_PATH}imageicons/chem.png`,
  SECOND_LANGUAGE: `${ASSET_PATH}imageicons/2nd-lang.png`,
  ACCOUNTANCY: `${ASSET_PATH}imageicons/accountancy.png`,
  ARABIC: `${ASSET_PATH}imageicons/arabic.png`,
  BIOLOGY: `${ASSET_PATH}imageicons/biology.png`,
  BUSINESS: `${ASSET_PATH}imageicons/busniess.png`,
  COMPUTER_SCIENCE: `${ASSET_PATH}imageicons/comp-sci.png`,
  ECONOMICS: `${ASSET_PATH}imageicons/economics.png`,
  ENGLISH: `${ASSET_PATH}imageicons/english.png`,
  HINDI: `${ASSET_PATH}imageicons/hindi.png`,
  HISTORY: `${ASSET_PATH}imageicons/history.png`,
  KANNADA: `${ASSET_PATH}imageicons/kannada.png`,
  MATHEMATICS: `${ASSET_PATH}imageicons/math.png`,
  PHYSICS: `${ASSET_PATH}imageicons/physics.png`,
  SCIENCE: `${ASSET_PATH}imageicons/science.png`,
  SOCIAL: `${ASSET_PATH}imageicons/social.png`,
  TAMIL: `${ASSET_PATH}imageicons/tamil.png`,
  URDU: `${ASSET_PATH}imageicons/urdu.png`,
  GENERAL_KNOWLEDGE: `${ASSET_PATH}imageicons/general knowledge.png`,
  INDIAN_ECONOMY: `${ASSET_PATH}imageicons/indian economy.png`,
  GENERAL_ENGLISH: `${ASSET_PATH}imageicons/eng.png`,
  APTITUDE: `${ASSET_PATH}imageicons/aptitude.png`,
  POLITICAL_SCIENCE: `${ASSET_PATH}imageicons/political.png`,
  ENVIRONMENT_SCIENCE: `${ASSET_PATH}imageicons/envir.png`,
  CURRENT_AFFAIRS: `${ASSET_PATH}imageicons/current affairs.png`,
  GENERAL_SCIENCE: `${ASSET_PATH}imageicons/gen_science.png`,
  GEOGRAPHY: `${ASSET_PATH}imageicons/geography.png`,
  SCHEDULEDTEST: 'https://static.upmyranks.com/unnamed.png',
  MOCK: 'https://static.upmyranks.com/test-icons-mock--upmyranks.png',
  CHAPTER: 'https://static.upmyranks.com/test-icon-chapter.png'
}
